// extracted by mini-css-extract-plugin
export var brand = "_2m-9";
export var button = "_2m-0";
export var chevron = "_2m-v";
export var chevronButton = "_2m-w";
export var content = "_2m-n";
export var danger = "_2m-g";
export var dangerOutlined = "_2m-h";
export var dark = "_2m-l";
export var darkTheme = "_2m-c";
export var extraSmall = "_2m-4";
export var fullWidth = "_2m-8";
export var ghost = "_2m-d";
export var gray = "_2m-t";
export var icon = "_2m-p";
export var iconButton = "_2m-s";
export var iconButtonBorder = "_2m-x";
export var iconButtonBorderDark = "_2m-y";
export var iconButtonBorderLight = "_2m-z";
export var iconLeft = "_2m-q";
export var iconRight = "_2m-r";
export var large = "_2m-1";
export var light = "_2m-m";
export var medium = "_2m-2";
export var micro = "_2m-5";
export var nano = "_2m-7";
export var outlined = "_2m-k";
export var pending = "_2m-a";
export var primary = "_2m-i";
export var shadow = "_2m-o";
export var small = "_2m-3";
export var solidLight = "_2m-e";
export var solidLightBrand = "_2m-f";
export var spinner = "_2m-u";
export var transparent = "_2m-j";
export var warning = "_2m-b";
export var wideNano = "_2m-6";